import React, { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { Card, CardBody } from "reactstrap";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import AppContext from "../../context/Context";

const Error404 = () => {
  const { loginUserDetails } = useContext(AppContext);

  const handleHomeRouter = () => {
    if (loginUserDetails.is_partner === "0") return `${process.env.PUBLIC_URL}/admin/dashboard`;
    else if (loginUserDetails.is_partner === "1")
      if (loginUserDetails.is_verified === "yes" && loginUserDetails.nda_status.toLowerCase() === "sent") {
        return `${process.env.PUBLIC_URL}/user/sign-nda`;
      } else {
        return `${process.env.PUBLIC_URL}/user/applications`;
      }
    else {
      return `${process.env.PUBLIC_URL}`;
    }
  };

  return (
    <Card className="text-center">
      <CardBody className="p-5">
        <div className="display-1 text-200 fs-error">404</div>
        <p className="lead mt-4 text-800 text-sans-serif font-weight-semi-bold">
          The page you're looking for is not found.
        </p>
        <hr />
        <p>
          Make sure the address is correct and that the page hasn't moved. If you think this is a mistake,
          <a href="mailto:info@exmaple.com" className="ml-1">
            contact us
          </a>
          .
        </p>
        <Link className="btn btn-primary btn-sm mt-3" to={handleHomeRouter}>
          <FontAwesomeIcon icon={faHome} className="mr-2" />
          Take me home
        </Link>
      </CardBody>
    </Card>
  );
};

export default Error404;
